import { group } from './group'
import { rule } from './rule'
import { user } from './user'

export const api = {
  user,
  rule,
  group
}
